"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminApiV1Api = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var AdminApiV1Api = /** @class */ (function (_super) {
    __extends(AdminApiV1Api, _super);
    function AdminApiV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * # Get the list of matching latest RRS values associated with Assays by from Concept Mapper. * Happy path: Return list of AYs and RRS values mappings.
     * Identify RRS values associated with Assays
     */
    AdminApiV1Api.prototype.getAssaysRRSMappingRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin-api/v1/assays-rrs-mapping",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * # Get the list of matching latest RRS values associated with Assays by from Concept Mapper. * Happy path: Return list of AYs and RRS values mappings.
     * Identify RRS values associated with Assays
     */
    AdminApiV1Api.prototype.getAssaysRRSMapping = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssaysRRSMappingRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * # Pin the assay provided to the RQ(s) This API will attempt to find the latest version of the RRS associated with the assay and map it to the requisition. * Happy path: There\'s a clear 1:1 mapping between the Assay and the RRS and all of the test selections present on the RQ are automatically upgraded to the requested Assay. * Exception flow #1: There is more than one RRS associated with the Assay. Hence the the required RRS cannot be picked to map the test selections on the RQ to the requested Assay. The API will return a ReReqSelectionError. * Exception flow #2: The current test selection on the RQ is empty. There\'s no way to map the RQ to the requested Assay as there are no test selections made. * Exception flow #3: The current test selection on the RQ cannot be mapped to the requested Assay as few or all of the tests in the test selection are missing on the requested Assay. * Exception flow #4: The current test selection on the RQ cannot be mapped to the requested Assay as few or all of the tests in the test selection are lower versioned than the current selection. * Exception flow #5: The current test selection is not eligible to be upgraded because of the processing stage it is in. Example - Cancelled, On-Hold.  The API will add any of the RQ(s) failing under Exception flow #2, #3, #4, #5 to failed RQ list with a 200 Response.
     * For the provided RQ(s) pin the requested assay
     */
    AdminApiV1Api.prototype.pinToAssayRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.body === null || requestParameters.body === undefined) {
                            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling pinToAssay.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin-api/v1/pin-to-assay",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.PinToAssayRequestToJSON)(requestParameters.body),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PinToAssayResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * # Pin the assay provided to the RQ(s) This API will attempt to find the latest version of the RRS associated with the assay and map it to the requisition. * Happy path: There\'s a clear 1:1 mapping between the Assay and the RRS and all of the test selections present on the RQ are automatically upgraded to the requested Assay. * Exception flow #1: There is more than one RRS associated with the Assay. Hence the the required RRS cannot be picked to map the test selections on the RQ to the requested Assay. The API will return a ReReqSelectionError. * Exception flow #2: The current test selection on the RQ is empty. There\'s no way to map the RQ to the requested Assay as there are no test selections made. * Exception flow #3: The current test selection on the RQ cannot be mapped to the requested Assay as few or all of the tests in the test selection are missing on the requested Assay. * Exception flow #4: The current test selection on the RQ cannot be mapped to the requested Assay as few or all of the tests in the test selection are lower versioned than the current selection. * Exception flow #5: The current test selection is not eligible to be upgraded because of the processing stage it is in. Example - Cancelled, On-Hold.  The API will add any of the RQ(s) failing under Exception flow #2, #3, #4, #5 to failed RQ list with a 200 Response.
     * For the provided RQ(s) pin the requested assay
     */
    AdminApiV1Api.prototype.pinToAssay = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.pinToAssayRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * # Upgrade Requisition\'s test selection to their respective latest version This API will attempt to find the latest versions of each test associated with the requisition. * Happy path: There\'s a clear 1:1 mapping and the test selection is automatically upgraded. * Happy path #2: The current test selection is still the _\"latest\"_ and no changes are done. * Exception flow #1: The current test selection is empty. There\'s no way to upgrade an empty test selection. * Exception flow #2: The current test selection doesn\'t map to an exact latest version. The API will return a ValidationError in the form of a 400 BadRequest. However, the user can pass `{\"forceUpdate\": true}` in the request body to force push the upgrade regardless of the error.
     * Upgrade test selection for a given requisition
     */
    AdminApiV1Api.prototype.upgradeTestSelectionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin-api/v1/upgrade-test-selection",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.TestSelectionUpgradeRequestToJSON)(requestParameters.body),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.TestSelectionUpgradeResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * # Upgrade Requisition\'s test selection to their respective latest version This API will attempt to find the latest versions of each test associated with the requisition. * Happy path: There\'s a clear 1:1 mapping and the test selection is automatically upgraded. * Happy path #2: The current test selection is still the _\"latest\"_ and no changes are done. * Exception flow #1: The current test selection is empty. There\'s no way to upgrade an empty test selection. * Exception flow #2: The current test selection doesn\'t map to an exact latest version. The API will return a ValidationError in the form of a 400 BadRequest. However, the user can pass `{\"forceUpdate\": true}` in the request body to force push the upgrade regardless of the error.
     * Upgrade test selection for a given requisition
     */
    AdminApiV1Api.prototype.upgradeTestSelection = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.upgradeTestSelectionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AdminApiV1Api;
}(runtime.BaseAPI));
exports.AdminApiV1Api = AdminApiV1Api;
